import React from "react";
import PropTypes from "prop-types";

import { makeStyles, useTheme } from "@material-ui/styles";
import { Box, AppBar, Tabs, Tab } from "@material-ui/core";

const faqs = [
    {
        id: "1",
        title: "Czym jest<br/>RSI?",
        text: "<p>Repozytorium Standardów Informacyjnych (w skrócie RSI) jest bazą wiedzy obejmującą metadane o rejestrach urzędowych i systemach informacyjnych administracji publicznej aktualizowaną przez gestorów oraz administratora RSI o wybrane rejestry/systemy za pomocą aplikacji internetowej Głównego Urzędu Statystycznego.</p><br><div style='display:flex' ><img src='images/certyfikat-icon.svg' alt='certyfikat ikona' style='width:50px; margin-right: 10px' /><p><a href='images/Certyfikat_Innowacyjnej_Praktyki_FZP_RSI.jpg' target='_blank' >Certyfikat innowacyjnej praktyki Forum Zarządzania Publicznego (JPG, 48KB)</a> dla Repozytorium Standardów Informacyjnych (RSI)<p></div>",
        icon: "images/icons/RSI_www-12.png",
    },
    {
        id: "2",
        title: "Jak w RSI<br/> zdefiniowano standard<br/> informacyjny?",
        text: "<p>Standard informacyjny to norma wprowadzona w drodze porozumienia przez grupę jednostek administracji publicznej, stanowiąca zobowiązanie do stosowania w prowadzonych systemach informacyjnych ustalonych standardów np.: identyfikatorów, klasyfikacji.</p>",
        icon: "images/icons/RSI_www-11.png",
    },
    {
        id: "3",
        title: "Jakie systemy<br/> opisuje RSI?",
        text: "<p>Repozytorium Standardów Informacyjnych opisuje: <ul><li>rejestry urzędowe - rejestry publiczne w rozumieniu ustawy z dnia 17 lutego 2005 r. o informatyzacji działalności podmiotów realizujących zadania publiczne (Dz.U. z 2021 r. poz. 2070 z późn. zm.) oraz inne rejestry i ewidencje prowadzone na podstawie ustaw lub wydanych na ich podstawie aktów wykonawczych, zawierające informacje o podmiotach gospodarki narodowej i ich działalności, informacje o osobach fizycznych, ich życiu i sytuacji oraz dotyczące zjawisk, zdarzeń i obiektów;</li><li>systemy informacyjne administracji publicznej - systemy zbierania, gromadzenia i przetwarzania informacji przez organy administracji publicznej, Zakład Ubezpieczeń Społecznych, Narodowy Fundusz Zdrowia, Komisję Nadzoru Finansowego, organy rejestrowe, inne państwowe lub samorządowe osoby prawne oraz inne podmioty prowadzące rejestry urzędowe.</li></ul></p>",
        icon: "images/icons/RSI_www-10.png",
    },
    {
        id: "4",
        title: "Dlaczego zbudowano<br/> RSI?",
        text: "<p>Dzięki rozwijaniu się technologii informacyjnych i komunikacyjnych powstają nowe  zasoby danych. Administracja publiczna buduje nowe systemy informacyjne i tworzy nowe standardy informacyjne.</p><p>Wprowadzanie w statystyce publicznej nowych źródeł danych spowodowało konieczność opracowania systemu do zarządzania metadanymi.</p><p>Informacje zgromadzone w RSI stanowią podstawę do oceny jakości i badania spójności systemów informacyjnych administracji publicznej z punktu widzenia użyteczności dla statystyki publicznej jako źródeł danych.</p><p>Zgromadzony w RSI zasób informacyjny ma charakter referencyjny i będzie mógł być przedmiotem analiz oraz stanowić podstawę do podejmowania decyzji o wykorzystaniu zasobów informacyjnych rejestrów urzędowych i systemów informacyjnych administracji publicznej prowadzonych przez inne instytucje oraz do modernizacji własnych rejestrów i systemów.</p><p>Zgromadzone opisy tworzą bazę wiedzy o rejestrach administracyjnych i systemach informacyjnych administracji publicznej, której jednym z głównych zadań jest wspieranie zapewnienia interoperacyjności systemów poprzez:<ul><li>stworzenie warunków do podniesienia jakości dziedzinowych systemów informacyjnych, w tym zwiększenia zgodności metodologicznej,</li><li>stworzenie warunków do zwiększenia efektywności dziedzinowych systemów informacyjnych w ramach poszczególnych działów, jak i systemu informacyjnego państwa, jako całości,</li><li>uzyskanie współdziałania systemów informacyjnych oraz ich interoperacyjności,</li><li>zwiększenie efektywności finansowej projektów realizowanych ze środków publicznych, w tym w ramach programów operacyjnych UE.</li></ul></p><p>Wykorzystanie RSI będzie miało pozytywny wpływ także na obniżenie obciążeń administracyjnych osób i podmiotów związanych z wielokrotnym dostarczaniem tych samych informacji do różnych jednostek administracji, w tym statystyki publicznej.</p><p>W efekcie ww. prac ułatwione będzie wyłonienie systemów referencyjnych, tj. takich, które gromadzą informacje pierwotnie, stanowią normy informacyjne, zapewniają aktualizację innym systemom administracji publicznej.</p>",
        icon: "images/icons/RSI_www-17.png",
    },
];

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
    },
    tabTitle: {
        textTransform: "none",
        fontWeight: 500,
        lineHeight: 1.4,
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.5rem",
        },
    },
    tabImg: {
        maxWidth: 72,
        [theme.breakpoints.down("sm")]: {
            maxWidth: 48,
        },
    },
    tabRoot: {
        alignItems: "baseline",
    },
    tabPanelText: {
        marginBottom: 30,
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.75rem",
        },
    },
    tabIndicator: {
        maxWidth: "17%",
        minWidth: "17%",
        marginLeft: "4%",
        "& span": {
            width: 0,
            height: 0,
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderTop: `6px solid ${theme.palette.primary.main}`,
            position: "absolute",
            top: 1,
            left: "50%",
            transform: "translateX(-50%)",
        },
    },
    overflowVisible: {
        overflow: "visible!important",
    },
}));

const TabsFAQ = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <AppBar position="static" color="transparent" elevation={0}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="tabs FAQ"
                    classes={{
                        indicator: classes.tabIndicator,
                        root: classes.overflowVisible,
                        fixed: classes.overflowVisible,
                    }}
                    TabIndicatorProps={{ id: "f-l-i", dangerouslySetInnerHTML: { __html: "<span/>" } }}
                >
                    {faqs.map((faq, i) => {
                        return (
                            <Tab
                                key={i}
                                label={
                                    <React.Fragment>
                                        <img className={classes.tabImg} src={faq.icon} alt={faq.title} />
                                        <div
                                            className={classes.tabTitle}
                                            dangerouslySetInnerHTML={{ __html: faq.title }}
                                        />
                                    </React.Fragment>
                                }
                                classes={{ root: classes.tabRoot }}
                                {...a11yProps(i)}
                            />
                        );
                    })}
                </Tabs>
            </AppBar>
            {faqs.map((faq, i) => {
                return (
                    <TabPanel value={value} index={i} dir={theme.direction} key={i}>
                        <div dangerouslySetInnerHTML={{ __html: faq.text }} className={classes.tabPanelText} />
                    </TabPanel>
                );
            })}
        </div>
    );
};

export default TabsFAQ;
